import { Injectable } from '@angular/core';
import { Subject, Observable }    from 'rxjs';

@Injectable()
export class UpdateStateService<T> {

  private stateBroadcaster = new Subject<T>();
  watchState:Observable<T>;

  constructor() {
    this.watchState = this.stateBroadcaster.asObservable();

  }

  updateState(newState: T){
    this.stateBroadcaster.next(newState);
  }
}
